import React, { useState, FunctionComponent, useEffect } from 'react';
import styles from './KanbanViewModal.module.css';
import axios from 'axios';
import { url } from '../../../Values/constants';
import { connect, useDispatch } from 'react-redux';
import { dateFieldList } from '../../../Values/tables';
import moment from 'moment';
import Select from 'react-select'
import { themeColors } from "../../theme";
import { Box, Grid, useMediaQuery, useTheme, Container } from "@mui/material";
import "../../../theme-vars.css";
import StyledSubmitButton from '../../Buttons/StyledSubmitButton';
import StyledCancelButton from '../../Buttons/StyledCancelButton';
import Modal, { Styles } from "react-modal";

type props = {
  panel: 'Contacts' | 'Tasks' | 'Call Logs';
  user: any;
  setTaskFilters: (data: any) => void;
  setContactsFilter: (data: any) => void;
  setCallsFilter: (data: any) => void;
  clearFilter: boolean;
  usersList: any[];
  setClearFilter?: (data: boolean) => void;
  hideDateFilter: any;
  theme: any;
  authToken: any;
  organizationSelectId?: any;
  onClose?: () => void; // add close callback
};

const KanbanViewFilter: FunctionComponent<props> = ({
  panel,
  user,
  setTaskFilters,
  setCallsFilter,
  setContactsFilter,
  clearFilter,
  usersList,
  setClearFilter,
  hideDateFilter,
  theme,
  authToken,
  organizationSelectId,
  onClose,
}) => {
  /* ----------------------------------------------------------
   Responsive theming helpers
---------------------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [filObj, setFilObj] = useState<any>({});
  const [contactFilterObject, setContactFilterObject] = useState<any>({});
  const [taskFilterObject, setTaskFilterObject] = useState<any>({});
  const [callFilterObject, setCallFilterObject] = useState<any>({});
  const [filterValue, setFilterValue] = useState<any>();
  const [dateArray, setDateArray] = useState<Array<{ item: string; from?: Date; to?: Date }>>([]);

  /* ----------------------------------------------------------
   On panel change → Load saved filters from localStorage
---------------------------------------------------------- */
  useEffect(() => {
    const contactFilterObj = localStorage.getItem("contactFilterObj") || "";
    const taskFilterObj = localStorage.getItem("taskFilterObj") || "";
    const callFilterObj = localStorage.getItem("callFilterObj") || "";
    const contactObj = contactFilterObj ? JSON.parse(contactFilterObj) : {}
    setContactFilterObject(contactObj);
    const taskObj = taskFilterObj ? JSON.parse(taskFilterObj) : {}
    setTaskFilterObject(taskObj);
    const callObj = callFilterObj ? JSON.parse(callFilterObj) : {}
    setCallFilterObject(callObj);
    setDateArray([]);
  }, [panel]);

  /* ----------------------------------------------------------
   Field grouping — defines which filters belong to each section
---------------------------------------------------------- */
  const taskList = ['completed_at', 'due_date', 'type', 'status',];
  const callsList = ['created_at', 'duration'];
  const contactsList = [
    'transfer_status',
    'stage',
    'contact_owner_email',
    'lead_source',
    'budget',
    'lead_type',
    'call_back_reason',
    'project',
    'property_type',
    'property_stage',
    'property_sub_type',
    'location',
    'next_follow_up_type',
    'next_follow_up_date_time',
    'created_at',
    'lead_assign_time',
    'stage_change_at',
    'addset',
    'campaign',
    'team',
    'branch',
    'previous_owner_1',
    'previous_owner_2',
    'previous_stage_1',
    'previous_stage_2',
    'transfer_by_1',
    'transfer_by_2',
    'reporting_to',
    'not_int_reason',
    'lost_reason',
  ];

  /* ----------------------------------------------------------
    Display Labels → Internal Filter Keys Mapping
 ---------------------------------------------------------- */
  const taskFilters: any = {
    'Transfer Status': 'transfer_status',
    Stage: 'stage',
    Owner: 'contact_owner_email',
    'Lead Source': 'lead_source',
    Budget: 'budget',
    'Call Back Reason': 'call_back_reason',
    Project: 'project',
    'Property Type': 'property_type',
    'Property Sub Type': 'property_sub_type',
    'Property Stage': 'property_stage',
    Location: 'location',
    Addset: 'addset',
    Campaign: 'campaign',
    Team: 'team',
    Branch: 'branch',
    'Reporting To': 'reporting_to',
    'Not Interested Reason': 'not_int_reason',
    'Lost Reason': 'lost_reason',
    'Completion Time': 'completed_at',
    'Task Type': 'type',
    'Created At': 'created_at',
    "Due Date & Time": 'due_date',
    'Lead Assign Date & Time': 'lead_assign_time',
    'Stage Change Date & Time': 'stage_change_at',
    Status: 'status',
  };

  const contactFilters: any = {
    'Transfer Status': 'transfer_status',
    Stage: 'stage',
    Owner: 'contact_owner_email',
    'Lead Source': 'lead_source',
    Budget: 'budget',
    "Lead Type": "lead_type",
    'Call Back Reason': 'call_back_reason',
    Project: 'project',
    'Property Type': 'property_type',
    'Property Sub Type': 'property_sub_type',
    'Property Stage': 'property_stage',
    Location: 'location',
    'Next Follow Up Type': 'next_follow_up_type',
    'Next Follow Up Date & Time': 'next_follow_up_date_time',
    'Created At': 'created_at',
    'Lead Assign At': 'lead_assign_time',
    'Call Response Time': 'call_response_time',
    'Stage Change At': 'stage_change_at',
    Addset: 'addset',
    Campaign: 'campaign',
    Team: 'team',
    Branch: 'branch',
    'Previous Owner 1': 'previous_owner_1',
    'Previous Owner 2': 'previous_owner_2',
    'Stage 1': 'previous_stage_1',
    'Stage 2': 'previous_stage_2',
    'Transfer By 1': 'transfer_by_1',
    'Transfer By 2': 'transfer_by_2',
    'Reporting To': 'reporting_to',
    'Not Interested Reason': 'not_int_reason',
    'Lost Reason': 'lost_reason',
    'Completion Time': 'completed_at',
    'Task Type': 'type',
    Status: 'status',
  };

  const callFilters: any = {
    'Transfer Status': 'transfer_status',
    Stage: 'stage',
    Owner: 'contact_owner_email',
    'Lead Source': 'lead_source',
    Budget: 'budget',
    Project: 'project',
    'Property Type': 'property_type',
    'Property Sub Type': 'property_sub_type',
    'Property Stage': 'property_stage',
    Location: 'location',
    Addset: 'addset',
    Campaign: 'campaign',
    Team: 'team',
    Branch: 'branch',
    'Reporting To': 'reporting_to',
    'Not Interested Reason': 'not_int_reason',
    'Lost Reason': 'lost_reason',
    'Created At': 'created_at',
    'Call Duration': 'duration',
  };


  /* ----------------------------------------------------------
       Fetch all filterable values from backend API
       - Contacts filters
       - Tasks filters
       - Call logs filters
    ----------------------------------------------------------- */
  const getContactsFilter = async () => {
    let finalFilter = {};

    // Append auth token to requests
    axios.defaults.headers.common['x-access-token'] = authToken

    // Fetch Contact Filters
    const res = await axios.post(url + '/leads/filterValues', {
      uid: user.uid || user?.auth_id || organizationSelectId?.value,
    });
    let l: any[] = [];
    if (res.data[0]) {
      l = Object.keys(res.data[0]);
      finalFilter = res.data[0];
    }
    axios.defaults.headers.common['x-access-token'] = authToken

    // Fetch Task Filters
    const taskRes = await axios.post(url + '/tasks/filterValues', {
      uid: user.uid || user?.auth_id || organizationSelectId?.value,
    });

    let tasks: { [key: string]: [] } = {};
    if (taskRes.data[0]) {
      Object.keys(taskRes.data[0]).forEach((key) => {
        if (!l.includes(key)) {
          tasks[key] = taskRes.data[0][key];
          l.push(key);
        }
      });
    }

    axios.defaults.headers.common['x-access-token'] = authToken

    // Fetch Call Filters
    const callRes = await axios.post(url + '/callLogs/filterValues', {
      uid: user.uid || user?.auth_id || organizationSelectId?.value,
    });
    let calls: { [key: string]: [] } = {};
    if (callRes.data[0]) {
      Object.keys(callRes.data[0]).forEach((key) => {
        if (!l.includes(key)) {
          calls[key] = callRes.data[0][key];
          l.push(key);
        }
      });
    }

    // Additional static filters
    let otherFilters = {
      transfer_status: ["True", "False"],
      lead_type: ['Data', 'Leads'],
      reporting_to: usersList,
      previous_owner_1: usersList,
      previous_owner_2: usersList,
      transfer_by_1: usersList,
      transfer_by_2: usersList,
      previous_stage_1: [
        'FRESH',
        'INTERESTED',
        'LOST',
        'WON',
        'NOT INTERESTED',
        'CALL BACK',
      ],
      previous_stage_2: [
        'FRESH',
        'INTERESTED',
        'LOST',
        'WON',
        'NOT INTERESTED',
        'CALL BACK',
      ],
      status: ['Completed', 'Pending', 'Overdue'],
    };

    finalFilter = { ...finalFilter, ...tasks, ...calls, ...otherFilters };
    setFilterValue(finalFilter);
  };

  /* ----------------------------------------------------------
     Fetch filters whenever user or token is available
  ---------------------------------------------------------- */
  useEffect(() => {
    if (user && authToken) {
      getContactsFilter();
    }
  }, [user, usersList, authToken]);

  /* ----------------------------------------------------------
     Transform raw filter values → Select dropdown list format
  ---------------------------------------------------------- */
  useEffect(() => {
    if (filterValue) {
      let contacts: { [key: string]: [] } = {};
      let obj = { ...contactFilters, ...taskFilters, ...callFilters };
      Object.keys(obj).forEach((key: any) => {
        let s = obj[key];
        contacts[key] = filterValue[s]?.map((va: any) => {
          return { "value": va, "label": va }
        });
      });
      setFilObj(contacts);
    }
  }, [filterValue]);

  /* ----------------------------------------------------------
    Clear everything when triggered by external state
 ---------------------------------------------------------- */
  useEffect(() => {
    if (clearFilter === true) {
      setDateArray([]);
      setTaskFilterObject({});
      setContactFilterObject({});
      setCallFilterObject({});
    }
  }, [clearFilter]);

  /* ----------------------------------------------------------
    Save filter selections → LocalStorage & Parent callback
 ---------------------------------------------------------- */
  const onSave = () => {
    localStorage.setItem('contactFilterObj', JSON.stringify(contactFilterObject));
    localStorage.setItem('taskFilterObj', JSON.stringify(taskFilterObject));
    localStorage.setItem('callFilterObj', JSON.stringify(callFilterObject));

    /* -----------------------------
      Prepare Contact filters
   ----------------------------- */
    let contactFilObj: { [key: string]: [] } = {};
    Object.entries(contactFilterObject).map(([key, value]) => {
      if (contactFilterObject[key].length > 0) {
        // Special case for boolean filter
        if (key === "transfer_status") {
          contactFilObj[key] = contactFilterObject[key]?.map((va: any) => {
            return va?.value ? va?.value === "False" ? false : true : va === "False" ? false : true;
          });
        } else {
          contactFilObj[key] = contactFilterObject[key]?.map((va: any) => {
            return va?.value ? va?.value : va;
          });
        }
      }
      else {
        return {};
      }
    })
    setContactsFilter(contactFilObj);

    /* -----------------------------
       Prepare Task filters
    ----------------------------- */
    let taskFilObj: { [key: string]: [] } = {};
    Object.entries(taskFilterObject).map(([key, value]) => {
      if (taskFilterObject[key].length > 0) {
        taskFilObj[key] = taskFilterObject[key]?.map((va: any) => {
          return va?.value ? va?.value : va;
        });
      }
      else {
        return {};
      }
    })
    setTaskFilters(taskFilObj);

    let callFilObj: { [key: string]: [] } = {};

    /* -----------------------------
       Prepare Call filters
    ----------------------------- */
    Object.entries(callFilterObject).map(([key, value]) => {
      if (callFilterObject[key].length > 0) {
        callFilObj[key] = callFilterObject[key]?.map((va: any) => {
          return va?.value ? va?.value : va;
        });
      }
      else {
        return {};
      }
    })
    // Notify parent
    setCallsFilter(callFilObj);
    onClose && onClose();
  };

  /* ----------------------------------------------------------
     Completely reset filter state
  ---------------------------------------------------------- */
  const clearKanbanFilters = () => {
    localStorage.clear();
    setDateArray([]);
    onClose && onClose();
  };

  /* ----------------------------------------------------------
     Handle From / To date selections → map into the right filter object
  ---------------------------------------------------------- */
  const setDateFilter = (
    date: Date | null,
    type: 'from' | 'to',
    item: string
  ) => {
    if (date === null) {
      return;
    }
    let tempDateArray = dateArray;
    if (type === 'from') {
      const newDate = moment(date).startOf('day').toDate();
      if (!tempDateArray.some((temp) => temp.item === item)) {
        tempDateArray.push({ item, from: newDate });
      } else {
        tempDateArray.forEach((temp) => {
          if (temp.item === item) temp.from = newDate;
        });
      }
    } else {
      const newDate = moment(date).endOf('day').toDate();
      if (!tempDateArray.some((temp) => temp.item === item))
        tempDateArray.push({ item, to: newDate });
      else {
        tempDateArray.forEach((temp) => {
          if (temp.item === item) temp.to = newDate;
        });
      }
    }
    setDateArray(tempDateArray);
    if (
      tempDateArray.some((temp) =>
        ['item', 'to', 'from'].every(key => Object.keys(temp).includes(key))
      )
    ) {
      let data = tempDateArray.find((temp) => temp.item === item);

      /* -----------------------------
    Assign date filter to correct module (Contact / Task / Call)
 ------------------------------ */
      if (panel === 'Contacts') {
        let contObj = { ...contactFilterObject };
        let taskObj: any = { ...taskFilterObject };
        let callObj: any = { ...callFilterObject };
        if (taskList.includes(contactFilters[item])) {
          taskObj[contactFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setTaskFilterObject(taskObj);
        } else if (contactsList.includes(contactFilters[item])) {
          contObj[contactFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setContactFilterObject(contObj);
        } else {
          callObj[contactFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setCallFilterObject(callObj);
        }
      }
      if (panel === 'Tasks') {
        let contObj = { ...contactFilterObject };
        let taskObj: any = { ...taskFilterObject };
        let callObj: any = { ...callFilterObject };
        if (taskList.includes(taskFilters[item])) {
          taskObj[taskFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setTaskFilterObject(taskObj);
        } else if (contactsList.includes(taskFilters[item])) {
          contObj[taskFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setContactFilterObject(contObj);
        } else {
          callObj[taskFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setCallFilterObject(callObj);
        }
      }
      if (panel === 'Call Logs') {
        let contObj = { ...contactFilterObject };
        let taskObj: any = { ...taskFilterObject };
        let callObj: any = { ...callFilterObject };
        if (callsList.includes(callFilters[item])) {
          callObj[callFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setCallFilterObject(callObj);
        } else if (contactsList.includes(callFilters[item])) {
          contObj[callFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setContactFilterObject(contObj);
        } else {
          taskObj[taskFilters[item]] = [
            data?.from?.toISOString(),
            data?.to?.toISOString(),
          ];
          setTaskFilterObject(callObj);
        }
      }
    }
  };

  // Example usage for font sizes
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeLarge = "var(--font-size-large)";

  /* ----------------------------------------------------------
     Modal Styling with Theme Support
  ---------------------------------------------------------- */
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme
        ? themeColors.cardBackgroundColor
        : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "10px 20px",
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      inset: "auto",
      margin: "auto",
    },
  };

  /* ----------------------------------------------------------
    Render Modal UI
 ---------------------------------------------------------- */
  return (
    <Modal
      isOpen={true} // or use a prop like isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={modalStyle}
      ariaHideApp={false}
    >
      {/* Header */}
      <div className={styles.header} style={{ marginTop: "10px", marginBottom: "20px" }} >
        <h2 className={styles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeLarge, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }}>Set Filters</h2>
      </div>

      {/* Filter Body */}
      <div className={styles.body} style={{ maxHeight: "62vh" }}>
        {
          /* ----------------------------------------------------
             RENDER FILTER LIST BASED ON PANEL TYPE
          ---------------------------------------------------- */
        }
        {/* CONTACT FILTERS */}
        {panel === 'Contacts' &&
          Object.keys(contactFilters).map((item) => (
            <>
              <div className={styles.tableContent} >

                {/* Filter Label */}
                <p
                  className={styles.item}
                >{item}</p>

                {/* Date filter → Render 'From' & 'To' */}
                {dateFieldList.includes(item) === true ? (
                  <>
                    <div className={styles.dateInputContainer}>
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '5px', marginBottom: '4px' }}
                      >
                        From:
                      </p>
                      <input
                        type="date"
                        id="from"
                        name="from"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.from)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.from
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'from', item);
                        }}
                      />
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '12px', marginBottom: '4px' }}
                      >
                        To:
                      </p>
                      <input
                        type="date"
                        id="to"
                        name="to"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.to)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.to
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'to', item);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <Select
                      isMulti
                      className={styles.multiselect_fields_value}
                      options={
                        filObj[item]
                      }
                      onChange={(val) => {
                        let contObj = { ...contactFilterObject };
                        let taskObj: any = { ...taskFilterObject };
                        let callObj: any = { ...callFilterObject };
                        if (taskList.includes(contactFilters[item])) {
                          taskObj[contactFilters[item]] = [...val];
                          setTaskFilterObject(taskObj);
                        }
                        else if (
                          contactsList.includes(contactFilters[item])
                        ) {
                          contObj[contactFilters[item]] = [...val];
                          setContactFilterObject(contObj);
                        } else {
                          callObj[contactFilters[item]] = [...val];
                          setCallFilterObject(callObj);
                        }
                      }}
                      value={contactFilterObject[contactFilters[item]] || taskFilterObject[contactFilters[item]] || callFilterObject[contactFilters[item]]}
                    />
                  </>
                )}
              </div>
            </>
          ))}

        {/* TASK FILTERS */}
        {panel === 'Tasks' &&
          Object.keys(taskFilters).map((item) => (
            <>
              <div className={styles.tableContent}>
                <p className={styles.item}>{item}</p>
                {dateFieldList.includes(item) ? (
                  <>
                    {console.log("itemitem", item)}
                    <div className={styles.dateInputContainer}>
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '5px', marginBottom: '4px' }}
                      >
                        From:
                      </p>
                      <input
                        type="date"
                        id="from"
                        name="from"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.from)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.from
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'from', item);
                        }}
                      />
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '12px', marginBottom: '4px' }}
                      >
                        To:
                      </p>
                      <input
                        type="date"
                        id="to"
                        name="to"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.to)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.to
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'to', item);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <Select
                    isMulti
                    className={styles.multiselect_fields_value}
                    options={
                      filObj[item]
                    }
                    onChange={(val) => {
                      let contObj = { ...contactFilterObject };
                      let taskObj: any = { ...taskFilterObject };
                      let callObj: any = { ...callFilterObject };
                      if (taskList.includes(taskFilters[item])) {
                        taskObj[taskFilters[item]] = [...val];
                        setTaskFilterObject(taskObj);
                      } else if (contactsList.includes(taskFilters[item])) {
                        contObj[taskFilters[item]] = [...val];
                        setContactFilterObject(contObj);
                      } else {
                        callObj[taskFilters[item]] = [...val];
                        setCallFilterObject(callObj);
                      }
                    }}
                    value={contactFilterObject[contactFilters[item]] || taskFilterObject[contactFilters[item]] || callFilterObject[contactFilters[item]]}
                  />
                )}
              </div>
            </>
          ))}

        {/* CALL LOG FILTERS */}
        {panel === 'Call Logs' &&
          Object.keys(callFilters).map((item) => (
            <>
              <div className={styles.tableContent}>
                <p className={styles.item}>{item}</p>
                {dateFieldList.includes(item) ? (
                  <>
                    <div className={styles.dateInputContainer}>
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '5px', marginBottom: '4px' }}
                      >
                        From:
                      </p>
                      <input
                        type="date"
                        id="from"
                        name="from"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.from)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.from
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'from', item);
                        }}
                      />
                      <p
                        className={styles.optionText}
                        style={{ marginTop: '12px', marginBottom: '4px' }}
                      >
                        To:
                      </p>
                      <input
                        type="date"
                        id="to"
                        name="to"
                        className={styles.dateInput}
                        value={
                          dateArray.some((i) => i.item === item && i.to)
                            ? moment(
                              dateArray.find((temp) => temp.item === item)
                                ?.to
                            ).format('YYYY-MM-DD')
                            : ''
                        }
                        onChange={(e) => {
                          setDateFilter(e.target.valueAsDate, 'to', item);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <Select
                    isMulti
                    className={styles.multiselect_fields_value}
                    options={
                      filObj[item]
                    }
                    onChange={(val) => {
                      let contObj = { ...contactFilterObject };
                      let taskObj: any = { ...taskFilterObject };
                      let callObj: any = { ...callFilterObject };
                      if (taskList.includes(callFilters[item])) {
                        taskObj[callFilters[item]] = [...val];
                        setTaskFilterObject(taskObj);
                      } else if (contactsList.includes(callFilters[item])) {
                        contObj[callFilters[item]] = [...val];
                        setContactFilterObject(contObj);
                      } else {
                        callObj[callFilters[item]] = [...val];
                        setCallFilterObject(callObj);
                      }
                    }}
                    value={contactFilterObject[contactFilters[item]] || taskFilterObject[contactFilters[item]] || callFilterObject[contactFilters[item]]}
                  />
                )}
              </div>
            </>
          ))}
      </div>
      {/* Footer Buttons */}
      <Box className={styles.bottom} sx={{ display: "flex", gap: "8px", justifyContent: "center" }}>
        <Box>
          <StyledCancelButton onClick={() => onClose && onClose()}>
            Cancel
          </StyledCancelButton>
        </Box>
        <Box>
          <StyledSubmitButton onClick={() => setClearFilter && setClearFilter(true) || clearKanbanFilters()}>
            Clear
          </StyledSubmitButton>
        </Box>
        <Box>
          <StyledSubmitButton onClick={onSave}>
            Save
          </StyledSubmitButton>
        </Box>
      </Box>
    </Modal>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(KanbanViewFilter);
